import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ImportFileCsvCreate } from './interfaces/importFileCsvCreate';
import { UserData } from './interfaces/user';

import { URL } from './../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppService {
  private readonly http = inject(HttpClient);

  isLogin = false;

  application = 'HBI';

  statusUpdated = new Subject<boolean>();

  applicationChanged = new Subject<string>();

  sheets = new Subject<ImportFileCsvCreate>();

  logStatusChange(status: boolean) {
    this.statusUpdated.next(status);
  }

  onAppChanged(appName: string) {
    this.applicationChanged.next(appName);
  }

  getUsersById(michelinId: string): Observable<UserData> {
    return this.http.get<UserData>(`${URL.url}${URL.users}${michelinId}`);
  }

  getUserDetails(): Observable<UserData> {
    return this.http.get<UserData>(`${URL.url}${URL.user}`);
  }
}
